<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Employee Attendance With Time</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="calendar_year"
                            :items="calendar_year_list" item-text="name" item-value="id" label="Year"
                            @change="getSalaryMonths()" outlined persistent-hint hint="Please Select Year" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.salary_month_list != ''">
                        <p><v-icon color="error">*</v-icon><b>Salary Month</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="salary_month"
                            :items="salary_month_list" item-text="sal_mon" item-value="id" label="Month" outlined
                            persistent-hint hint="Please Select Month" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Employee Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type"
                            :items="employee_type_list" item-text="name" item-value="id" label="Employee Type" outlined
                            persistent-hint hint="Please Select Employee Type" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <p><v-icon color="error">*</v-icon><b>Designation</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="designation"
                            :items="designation_list" item-text="name" item-value="id" label="Designation" outlined
                            persistent-hint hint="Please Select Designation" />
                    </v-col>

                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Employee Section</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_section"
                            :items="employee_section_list" item-text="name" item-value="id" label="Employee Section"
                            outlined persistent-hint hint="Please Select Employee Section" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Employee Shift</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="shift"
                            :items="employee_shift_list" item-text="name" item-value="id" label="Employee Shift"
                            outlined persistent-hint hint="Please Select Employee Shift" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Employee </b></p>
                        <v-autocomplete color="#0F2027" multiple dense rounded required v-model="employee"
                            :items="employee_list" item-text="name" item-value="id" label="Employee" outlined
                            persistent-hint hint="Please Select Employee" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-row justify="center" dense>
                            <v-radio-group v-model="radios" mandatory row class="mt-10 no-display">
                                <v-radio label="Lite" value="lite" color="#0f2027"></v-radio>
                                <v-radio label="Classic" value="classic" color="#0f2027"></v-radio>
                            </v-radio-group>
                        </v-row>
                    </v-col>
                    <v-col class="pt-5 mt-5" cols="12" sm="3" md="3">
                        <v-btn @click="getReport()" class="button" v-if="salary_month">
                            Fetch Report
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col v-if="attendance_details != ''" v-for="(co, index) in colors_list[0]" :key="index" cols="12"
                        sm="3" md="3">
                        <v-chip x-small label class="ma-1" :color="co" text-color="white"> </v-chip>
                        - <strong> {{ index }} </strong>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="attendance_details != ''">
                        <strong> Preference: </strong><br />
                        <strong>1.</strong> In-out time <strong>2.</strong> Leave <strong>3.</strong> Holiday
                        <strong>4.</strong> Weekly Off
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" md="6">
                        <v-btn rounded color="success" v-if="attendance_details != ''" outlined
                            @click="fnExcelReport('my-table-id', 'EmployeeAttendanceReport')" :loading="loader"><v-icon
                                color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                </v-row>
                <div id="my-table-id" class="view" v-if="attendance_details != '' && this.radios=='classic'">
                    <v-simple-table fixed-header dense class="elevation-1" height="500px"
                        v-if="attendance_details != ''">
                        <thead>
                            <tr>
                                <th style="background-color: #edeef7;">
                                    <strong> Day</strong>
                                </th>
                                <th style="background-color: #edeef7;" v-for="(s1, index1) in daysArray" :key="index1">
                                    <strong>{{ s1 }}</strong>
                                </th>
                                <th style="background-color: #edeef7;">
                                    <strong>P</strong>
                                </th>
                                <th style="background-color: #edeef7;">
                                    <strong>A</strong>
                                </th>
                                <th style="background-color: #edeef7;">
                                    <strong>WO</strong>
                                </th>
                                <th style="background-color: #edeef7;">
                                    <strong>H</strong>
                                </th>
                                <th style="background-color: #edeef7;">
                                    <strong>Late Cnt</strong>
                                </th>
                                <th style="background-color: #edeef7;">
                                    <strong>Early Cnt</strong>
                                </th>
                                <th style="background-color: #edeef7;">
                                    <strong>Leave Cnt</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-for="(s, index) in attendance_details" :key="index">
                            <tr style="background-color: #30aadd; color: white;">
                                <th :colspan="weekdaysArray.length + 8">{{ s.inst_name }}</th>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #e4fbff;">Days</th>
                                <th style="background-color: #e4fbff;" v-for="(s, index) in weekdaysArray" :key="index">
                                    {{ s }}
                                </th>
                                <th style="background-color: #e4fbff;"></th>
                                <th style="background-color: #e4fbff;"></th>
                                <th style="background-color: #e4fbff;"></th>
                                <th style="background-color: #e4fbff;"></th>
                                <th style="background-color: #e4fbff;"></th>
                                <th style="background-color: #e4fbff;"></th>
                                <th style="background-color: #e4fbff;"></th>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">Day</th>
                                <th style="background-color: #edeef7;" v-for="(s1, index1) in daysArray" :key="index1">
                                    {{ s1 }}
                                </th>
                                <th style="background-color: #edeef7;">P</th>
                                <th style="background-color: #edeef7;">A</th>
                                <th style="background-color: #edeef7;">WO</th>
                                <th style="background-color: #edeef7;">H</th>
                                <th style="background-color: #edeef7;">Late Cnt</th>
                                <th style="background-color: #edeef7;">Early Cnt</th>
                                <th style="background-color: #edeef7;">Leave Cnt</th>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">P / A</th>
                                <td v-for="(s2, index2) in s.status_list" :key="index2">
                                    <v-tooltip top color="green">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip label class="ma-1" :color="s2.color" text-color="white"
                                                v-bind="attrs" v-on="on">
                                                {{ s2.type }}
                                            </v-chip>
                                        </template>
                                        <span> {{ s2.remark }} </span>
                                    </v-tooltip>
                                </td>
                                <td>{{ s.present }}</td>
                                <td>{{ s.abs_count }}</td>
                                <td>{{ s.weekoff }}</td>
                                <td>{{ s.holiday }}</td>
                                <td>{{ s.late_count }}</td>
                                <td>{{ s.early_count }}</td>
                                <td>{{ s.leave }}</td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Exp. In
                                </th>
                                <td v-for="(s3, index8) in s.expected_in_time_list" :key="index8">
                                    {{ s3 }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Exp. Out
                                </th>
                                <td v-for="(s3, index9) in s.expected_out_time_list" :key="index9">
                                    {{ s3 }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Exp. Hrs.
                                </th>
                                <td v-for="(s3, index0) in s.expectednoofhours_list" :key="index0">
                                    {{ s3 }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    In Time
                                </th>
                                <td v-for="(s3, index3) in s.in_time_list" :key="index3">
                                    {{ s3 }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Out Time
                                </th>
                                <td v-for="(s4, index4) in s.out_time_list" :key="index4">
                                    {{ s4 }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Duration
                                </th>
                                <td v-for="(s5, index7) in s.duration_list" :key="index7">
                                    {{ s5 }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Late(Min)
                                </th>
                                <td v-for="(s6, index6) in s.late_list" :key="index6">
                                    {{ s6.mins }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Early(Min)
                                </th>
                                <td v-for="(s7, index5) in s.early_list" :key="index5">
                                    {{ s7.mins }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Remark
                                </th>
                                <td v-for="(s7, index12) in s.remark_list" :key="index12">
                                    {{ s7 }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <div id="my-table-id" class="view" v-if="attendance_details != '' && this.radios=='lite'">
                    <v-simple-table fixed-header dense class="elevation-1" height="500px"
                        v-if="attendance_details != ''">
                        <thead>
                            <tr>
                                <th style="background-color: #edeef7;">
                                    <strong> Day</strong>
                                </th>
                                <th style="background-color: #edeef7;" v-for="(s1, index1) in daysArray" :key="index1">
                                    <strong>{{ s1 }}</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-for="(s, index) in attendance_details" :key="index">
                            <tr style="background-color: #30aadd; color: white;">
                                <th :colspan="weekdaysArray.length + 8">{{ s.inst_name }}</th>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #e4fbff;">Days</th>
                                <th style="background-color: #e4fbff;" v-for="(s, index) in weekdaysArray" :key="index">
                                    {{ s }}
                                </th>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">Day</th>
                                <th style="background-color: #edeef7;" v-for="(s1, index1) in daysArray" :key="index1">
                                    {{ s1 }}
                                </th>
                            </tr>
                            <!-- <tr>
                              <th class="headcol" style="background-color: #edeef7;">P / A</th>
                              <td v-for="(s2, index2) in s.status_list" :key="index2">
                                  <v-tooltip top color="green">
                                      <template v-slot:activator="{ on, attrs }">
                                          <v-chip label class="ma-1" :color="s2.color" text-color="white" v-bind="attrs" v-on="on">
                                              {{ s2.type }}
                                          </v-chip>
                                      </template>
                                      <span> {{ s2.remark }} </span>
                                  </v-tooltip>
                              </td>
                          </tr> -->
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Exp. In
                                </th>
                                <td v-for="(s3, index8) in s.expected_in_time_list" :key="index8">
                                    {{ s3 }}
                                </td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Exp. Out
                                </th>
                                <td v-for="(s3, index9) in s.expected_out_time_list" :key="index9">
                                    {{ s3 }}
                                </td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Exp. Hrs.
                                </th>
                                <td v-for="(s3, index0) in s.expectednoofhours_list" :key="index0">
                                    {{ s3 }}
                                </td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    In Time
                                </th>
                                <td v-for="(s3, index3) in s.in_time_list" :key="index3">
                                    {{ s3 }}
                                </td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Out Time
                                </th>
                                <td v-for="(s4, index4) in s.out_time_list" :key="index4">
                                    {{ s4 }}
                                </td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Duration
                                </th>
                                <td v-for="(s5, index7) in s.duration_list" :key="index7">
                                    {{ s5 }}
                                </td>
                            </tr>
                            <tr>
                                <th class="headcol" style="background-color: #edeef7;">
                                    Remark
                                </th>
                                <td v-for="(s7, index12) in s.remark_list" :key="index12">
                                    {{ s7 }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-card>
        </v-container>
    </div>
</template>
<script>
  import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
      data: () => ({
          selected: [],
          total_teachers: [],
          loader: false,
          radios: null,
          snackbar_msg: "",
        //   extraBreadcrumbItems: [


        //   ],
        //   breadcrumbClass: "breadcrumb-style1",
          color: "",
          snackbar: false,
          overlay: false,
          title: "",
          description: "",
          search: "",
          calendar_year_list: [],
          calendar_year: null,
          salary_month_list: [],
          salary_month: null,
          employee_type_list: [],
          employee_type: null,
          employee_section_list: [],
          employee_shift_list: [],
          employee_section: null,
          shift: null,
          employee_list: [],
          employee: [],
          designation_list: [],
          designation: null,
          weekdaysArray: [],
          daysArray: [],
          attendance_details: [],
          colors_list: [],
          org_basic_data: [],
      }),
      methods: {
          fnExcelReport(id, name) {
              var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
              tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
              tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
              tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
              tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
              tab_text = tab_text + "<table border='1px'>";
              var exportTable = $("#" + id).clone();
              exportTable.find("input").each(function (index, elem) {
                  $(elem).remove();
              });
              tab_text = tab_text + exportTable.html();
              tab_text = tab_text + "</table></body></html>";
              var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

              //Save the file
              // var blob = new Blob([tab_text], {
              //   type: "application/vnd.ms-excel;charset=utf-8",
              // });
              // window.saveAs(blob, fileName);
              const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
              const filename = name + ".xls";

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  // For IE
                  window.navigator.msSaveOrOpenBlob(blob, filename);
              } else {
                  // For modern browsers
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = filename;
                  a.click();
                  window.URL.revokeObjectURL(url);
              }
          },
          setNull() {
              (this.employee_list = []),
                  (this.employee = ""),
                  (this.leave_status_list = []),
                  (this.leave_status = ""),
                  (this.employee_type_list = []),
                  (this.employee_type = ""),
                  (this.employee_section_list = []),
                  (this.employee_shift_list = []),
                  (this.employee_section = "");
              this.shift = null;
              (this.salary_month_list = []), (this.salary_month = "");
          },
          getSalaryMonths() {
              //this.setNull();
              const data = {
                  year: this.calendar_year,
              };
              this.overlay = true;
              axios
                  .post("/Payroll/getSalaryMonth", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.salary_month_list = res.data.sal_month_list;
                      } else {
                          this.showSnackbar("red", res.data.snackbar);
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                      this.overlay = false;
                  })
                  .catch((error) => {
                      this.onerror(error);
                      this.overlay = false;
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },
          getReport() {
              const data = {
                  employee: this.employee,
                  sal_month: this.salary_month,
                  employee_type: this.employee_type,
                  designation: this.designation,
                  section: this.employee_section,
                  shift: this.shift,
                  radios:this.radios,
              };
              this.overlay = true;
              if(this.radios == 'classic'){
              axios
                  .post("/EmployeeBiometric/getEmpAttendanceWithTimeReport_old", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.weekdaysArray = res.data.weekdaysArray;
                          this.daysArray = res.data.daysArray;
                          this.attendance_details = res.data.attendance_details;
                          this.colors_list = res.data.colors_list;
                          this.org_basic_data = res.data.org_basic_data;
                      } else {
                          this.showSnackbar("red", res.data.snackbar);
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                      this.overlay = false;
                  })
                  .catch((error) => {
                      this.onerror(error);
                      this.overlay = false;
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
                }
                else{
              axios
                  .post("/EmployeeBiometric/getEmpAttendanceWithTimeReport_lite", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.weekdaysArray = res.data.weekdaysArray;
                          this.daysArray = res.data.daysArray;
                          this.attendance_details = res.data.attendance_details;
                          this.colors_list = res.data.colors_list;
                          this.org_basic_data = res.data.org_basic_data;
                      } else {
                          this.showSnackbar("red", res.data.snackbar);
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                      this.overlay = false;
                  })
                  .catch((error) => {
                      this.onerror(error);
                      this.overlay = false;
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
                }
          },
          getReport_new() {
              const data = {
                  employee: this.employee,
                  sal_month: this.salary_month,
                  employee_type: this.employee_type,
                  designation: this.designation,
                  section: this.employee_section,
                  shift: this.shift,
              };
              this.overlay = true;
              axios
                  .post("/EmployeeBiometric/getEmpAttendanceWithTimeReport_new", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.weekdaysArray = res.data.weekdaysArray;
                          this.daysArray = res.data.daysArray;
                          this.attendance_details = res.data.attendance_details;
                          this.colors_list = res.data.colors_list;
                          this.org_basic_data = res.data.org_basic_data;
                      } else {
                          this.showSnackbar("red", res.data.snackbar);
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                      this.overlay = false;
                  })
                  .catch((error) => {
                      this.onerror(error);
                      this.overlay = false;
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },
          onLoad() {
              axios
                  .post("EmployeeBiometric/getPayrollInfo")
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                          this.calendar_year_list = res.data.calendar_year_list;
                          this.employee_type_list = res.data.employee_type_list;
                          this.employee_section_list = res.data.employee_section_list;
                          this.employee_shift_list = res.data.employee_shift_list;
                          this.employee_list = res.data.instructor_list;
                          this.designation_list = res.data.designation_list;
                          this.overlay = false;
                      } else {
                          this.showSnackbar("#b71c1c", res.data.status_reason);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong!!!");
                      this.overlay = false;
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },
      mounted() {
          this.onLoad();
      },
      watch: {},
  };
</script>
<style scoped>
  /* .v-text-field{
    width: 80px;
} */
  .table {
      border: none !important;
  }
  thead {
      font-weight: bold !important;
  }
  th {
      font-weight: bold !important;
  }
  tr,
  td,
  th {
      border: 1px solid black;
      /* text-align: center; */
      font-size: small;
  }
  tr,
  tbody {
      border-bottom: 1px solid black;
      border: 1px solid black;
      font-size: small;
  }
  td {
      font-size: small;
  }
  .weaklyoff {
      background: white !important;
  }
  .weaklyoff2 {
      background: yellow !important;
  }
  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
          font-size: small;
      }
      td + td,
      th + th {
          width: auto;
          font-size: small;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      /* text-align: center; */
      font-size: small;
  }

  .edit-avatar {
      transition: 0.3s;
      border: 1px solid #b0bec5;
  }
  .edit-avatar:hover {
      background-color: #b0bec5;
  }
  .edit-v-icon {
      padding-left: 6px;
      font-size: 15px;
  }
  .edit-v-icon:hover {
      color: white;
  }

  .view {
      width: 100%;
      margin-left: 0%;
      padding: 0;
  }

  .headcol {
      position: sticky;
      left: 0;
      top: auto;
      z-index: 1;
  }
</style>
